module.exports = __webpack_public_path__ + "img/product_121.4623ab8.webp";